const overrides: Record<string, Record<string, string>> = {
  
  kn: {
    "Resources": "ರಿಸೋರ್ಸ್ಗಳು",
    "Quikstep": "ಕ್ವಿಕ್ ಸ್ಟೆಪ್", 
    // "No Missed Calls or Unread Chats":"ಮಿಸ್ಡ್ ಕಾಲ್‌ಗಳು / ಓದದಿರುವ ಚಾಟ್‌ಗಳಿಲ್ಲ"
    // add more kn overrides here
  },ko: {
    "Quikstep": "퀵스텝",       
    "Resources": "리소스", 
  },
  // add more languages here same way
};

export const getOverride = (word: string, lang: string): string | null => {
  return overrides[lang]?.[word] ?? null;
};